import React, { useState } from "react"
import i18n from "../../i18n"
import { useLanguageContext } from "./LanguageContext"
import en from "antd/lib/locale/en_US"
import ko from "antd/lib/locale/ko_KR"
import sv from "antd/lib/locale/sv_SE"
import { ConfigProvider } from "antd"

const locales = {
  en,
  ko,
  sv,
}

const getLocale = (lang: string) => {
  // i18next는 "sv-SE" 같은 region 코드도 넘겨주므로 앞부분만 본다.
  const base = (lang || "").split("-")[0]
  if (base in locales) {
    return locales[base]
  }
  return locales["en"]
}
export const AntdLanguageProvider: React.FC<React.PropsWithChildren> = (props) => {
  const { lang } = useLanguageContext()
  const [locale, setLocale] = useState(getLocale(lang))

  i18n.on("languageChanged", (newLang) => setLocale(getLocale(newLang)))

  return <ConfigProvider locale={locale} theme={{ token: { colorPrimary: "#4F46E5" } }}>{props.children}</ConfigProvider>
}
